import React, { useState } from "react";
import PropTypes from "prop-types";
import SeeMore from "../SeeMore";
import ResponseMessage from "../ResponseMessage";
import List from "./List";

const INIT_LIMIT = 3;

const ExhibitionsList = ({
  exhibitions,
  showAll,
  noResultsMessage,
  onArtistPage,
  isLoading,
  onNextPage,
}) => {
  const [isExpanded, setIsExpanded] = useState(showAll);

  const showSeeMore =
    onNextPage || (!isExpanded && exhibitions.length > INIT_LIMIT);

  if (exhibitions.length === 0 && !!noResultsMessage)
    return <ResponseMessage message={noResultsMessage} />;

  return (
    <>
      <List
        exhibitions={
          isExpanded || onNextPage
            ? exhibitions
            : exhibitions.slice(0, INIT_LIMIT)
        }
        isLoading={isLoading}
        onArtistPage={onArtistPage}
      />
      {showSeeMore && (
        <SeeMore
          onClick={() => (onNextPage ? onNextPage() : setIsExpanded(true))}
        />
      )}
    </>
  );
};

ExhibitionsList.propTypes = {
  exhibitions: PropTypes.array,
  noResultsMessage: PropTypes.string,
  onArtistPage: PropTypes.bool,
  isLoading: PropTypes.bool,
  showAll: PropTypes.bool,
  onNextPage: PropTypes.func,
};

export default ExhibitionsList;
